import type { TemplateField } from '@/modules/template';

/**
 * Deal-specific fields an author can inject into the share form. Like the
 * event form, the message fields already live in the tone itself, and the
 * deal's date/time is supplied by primitives (e.g. `{_smartStartDate}`),
 * so there are no extra injectable fields yet. The seam is here for when the
 * deal form gains type-specific insertable fields.
 */
export const dealInjectableFields: readonly TemplateField[] = [];
